<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('ico-to-png-converter', 'ICO → PNG');

// Merge base config with ICO→PNG specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.ico-to-png',
  outputFormat: 'png',  // Required for smart compression option to show after Vue hydration
  labels: {
    dropzoneHeading: 'Drop ICO Files Here',
    emptyQueueMessage: 'Drop ICO files to start your first conversion.',
    statsLabel: 'Median ICO → PNG time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files...',
  },
  showOptionsPanel: true,  // V2: Enable resize/compression options panel
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[ICO Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[ICO Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[ICO Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[ICO Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[ICO Converter] Credits updated:', credits);
}
</script>
